import styled from 'styled-components';

export const DisclaimerWrapper = styled.div`
.has-text-align-justify{
    text-align:justify;
}
.has-text-align-left{
    text-align:left;
}
`;
